import { css } from 'styled-components';

export const getNavbarInnerWrapperCss = ():any => css`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
`;
export default { getNavbarInnerWrapperCss };
